/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useContext} from 'react'

import Context from '@s-ui/react-context'

import {ICONS_MAP} from '../config.js'

const useFilterGroups = ({filters, listingSectionId, searchTags, accordionsOpenedByDefault}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTERS_GROUPS_IDS, FILTERS_BY_GROUPS_IDS, FILTERS_GROUPS_BY_LISTING_SECTION_ID} = config.get('filtersGroups')
  const {FILTERS_LABELS} = config.get('filtersLabels')
  const {FILTERS_OPTIONS} = config.get('filtersOptions')
  const {FILTERS_PLACEHOLDERS} = config.get('filtersPlaceholders')

  const getGroups = useCallback(
    () =>
      Object.entries(FILTERS_GROUPS_BY_LISTING_SECTION_ID[listingSectionId] || {})
        .map(([groupId, {icon: groupIcon, label: groupLabel, filters: groupFilters}]) => {
          const availableFilters = filters
            .map(
              ({component, name, ...rest}) =>
                groupFilters.includes(name) && {
                  component,
                  label: FILTERS_LABELS[name],
                  name,
                  options: FILTERS_OPTIONS[name],
                  placeholder: FILTERS_PLACEHOLDERS[name],
                  ...rest
                }
            )
            .filter(Boolean)

          const availableFiltersFlat = availableFilters.flatMap(({name}) =>
            Object.values(FILTERS_GROUPS_IDS).includes(name) ? FILTERS_BY_GROUPS_IDS[name] : name
          )

          const idsSet = new Set(availableFiltersFlat)

          return (
            availableFilters.length && {
              count: searchTags.reduce((acc, {field}) => (idsSet.has(field) ? acc + 1 : acc), 0),
              filters: availableFilters,
              icon: ICONS_MAP[groupIcon],
              groupId,
              label: i18n.t(groupLabel),
              isOpenedByDefault: accordionsOpenedByDefault[groupId]
            }
          )
        })
        .filter(Boolean),
    [filters, searchTags]
  )

  return {groups: getGroups()}
}

export default useFilterGroups
